import React from 'react'
import { FC } from 'react'
import { Key as keyCodes } from 'ts-keycode-enum'

import { DataGridCell } from '@imodules/react-components/controls/DataGridCell'

export interface ShowContentProps { verbiage: string, isExpanded: boolean }

export interface ShowAllRowProps {
    showAllVerbiage: string
    overrideDisplayLimit: boolean
    toggleOverrideDisplayLimit: () => void
}

export const ShowContent: FC<ShowContentProps> = (props: ShowContentProps) =>
    <>
        {props.isExpanded
            ? <span className="fa fa-chevron-circle-up fa-lg" aria-expanded={props.isExpanded} aria-label="collapse all" />
            : (props.verbiage || <span className="fa fa-chevron-circle-down fa-lg" aria-expanded={props.isExpanded} aria-label="expand all" />)}
    </>
ShowContent.displayName = 'ShowContent'

export const ShowAllRow: FC<ShowAllRowProps> = props =>
    <ul tabIndex={0} className="data-grid-row" onClick={props.toggleOverrideDisplayLimit} onKeyDown={handleKeyDown(props.toggleOverrideDisplayLimit)}>
        <DataGridCell
            className="show-all-column data-grid-column "
            widthType={{ kind: 'fixedWidth', fixedWidth: '100%' }}
            isColumnHeader={false}
        >
            <ShowContent verbiage={props.showAllVerbiage} isExpanded={props.overrideDisplayLimit} />
        </DataGridCell>
    </ul>
ShowAllRow.displayName = 'ShowAllRow'

const handleKeyDown = (onChange: () => void) => (event: React.KeyboardEvent<HTMLUListElement>) => {
    switch (event.keyCode) {
        case keyCodes.Space:
        case keyCodes.Enter:
            event.preventDefault()
            event.stopPropagation()
            onChange()
    }
}
